class Config {
  baseUrl: string = process.env.REACT_APP_BASE_URL!

  zumoOrgId: string = process.env.REACT_APP_ZUMO_ORG_ID!

  weexOrgId: string = process.env.REACT_APP_WEEX_ORG_ID!

  manualTestingOrgId: string = process.env.REACT_APP_MANUAL_TESTING_ORG_ID!

  defaultKnowledgeHubUrl: string =
    process.env.REACT_APP_DEFAULT_KNOWLEDGE_HUB_URL!
}

const config = new Config()

export default config
